import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, Autoplay } from "swiper/modules";

const testimonials = [
  { 
    name: "Rahul Verma", 
    feedback: "ZajraGreen built a professional football turf for our academy. Excellent quality and timely installation. Highly recommended!" 
  },
  { 
    name: "Sunny Sports Arena", 
    feedback: "Our box cricket turf looks premium and players love the bounce quality. Great workmanship and finishing." 
  },
  { 
    name: "Alpha Sports Club", 
    feedback: "Very satisfied with the multi-sport court installation. Smooth surface and perfect line markings." 
  },
  { 
    name: "Coach Amit", 
    feedback: "The drainage system works perfectly even during heavy rain. ZajraGreen delivered exactly what we needed." 
  },
  { 
    name: "Green Valley School", 
    feedback: "Kids love the new playground turf. Safe, soft, and durable. Thank you for amazing service!" 
  },
  { 
    name: "Pro Turf Arena", 
    feedback: "Professional team with great knowledge of turf engineering. Installation was smooth and hassle-free." 
  },
];

const Testimonials = () => {
  return (
    <section className="py-16 px-6 md:px-24 text-center bg-gray-50">
      
      {/* Heading */}
      <h2 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent mb-8">
        What Our Clients Say
      </h2>

      {/* Slider */}
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="pb-8"
      >
        {testimonials.map((t, index) => (
          <SwiperSlide key={index}>
            <div className="bg-white p-6 rounded-xl shadow hover:shadow-xl transition h-full flex flex-col justify-between border border-gray-100">
              <p className="text-gray-700 mb-4 text-base leading-relaxed">
                "{t.feedback}"
              </p>
              <p className="font-semibold text-green-700 mt-auto">- {t.name}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
